/** Query param for contest registration landing flow (?contest-registration=true) */
export const CONTEST_REGISTRATION_PARAM = 'contest-registration';
